import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import BASEURL from "../../Utils/Baseurl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { Card, Stack, CardHeader } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import UserDetailsContext from "../../../context/auth";
import { getAllLeaveConfiguration } from "./Component/api";

const LeaveConfiguration = () => {
  const navigate = useNavigate();

  const { user, AccessData } = useContext(UserDetailsContext);
  const id = user?.id;

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [wfhList, setWfhList] = useState([]);

  useEffect(() => {
    onWfhSubmit();
  }, []);

  const wfhListTable = {
    columns: [
      {
        field: "leaveType",
        headerName: "Leave Type",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "numberOfDays",
        headerName: "Number Of Days",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "period",
        headerName: "Period",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "employeeType",
        headerName: "Employee Type",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
    ],
    rows: (wfhList || []).map((wfh) => ({
      id: wfh.id,
      leaveType: wfh.leaveType,
      numberOfDays: wfh.numberOfDays,
      period: wfh.period,
      employeeType: wfh.employeeType,
    })),
  };

  const handleNewWfh = () => {
    navigate("/leave-configuration/add-leaveconfiguration");
  };
  const onWfhListClick = (e) => {
    if (e?.id) {
      navigate(`/leave-configuration/add-leaveconfiguration?id=${e?.id}`);
    }
  };
  const onWfhSubmit = async () => {
    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: getAllLeaveConfiguration,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Check and handle the response
      const data = response.data.data.allLeaveConfigurations;

      setWfhList(data);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseEsssrror:", error.response.data);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Leave Configuration List
                </MaterialTypography>
                {/* <MaterialTypography variant="caption" color="text">
                                List of WFH that you can get details of WFH.
                            </MaterialTypography> */}
              </Stack>
              {/* {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddLeaveConfiguration" && item.can_access
                ) && ( */}
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewWfh()}
              >
                Leave Configuration
              </MaterialButton>
              {/* )} */}
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={wfhListTable.rows}
          columns={wfhListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onWfhListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No Work From Home found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any Work From Home details. Click on
                  the "Add Work From Home" button to start adding Work From Home
                  details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default LeaveConfiguration;
